<template>
<div class="home">
    <section class="hero-section">
      <div class="hero-bg">
        <div class="hero-shape hero-shape-1"></div>
        <div class="hero-shape hero-shape-2"></div>
        <div class="hero-shape hero-shape-3"></div>
      </div>
      <div class="container">
        <div class="hero-content">
          <div class="hero-text">
            <div class="hero-badge">
              <svg viewBox="0 0 20 20" fill="currentColor">
                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/>
              </svg>
              <span>专业少儿编程教育平台</span>
            </div>
            <h1 class="hero-title">
              <span class="title-line">让孩子爱上编程</span>
              <span class="title-line title-highlight">开启智慧未来</span>
            </h1>
            <p class="hero-subtitle">985高校师资团队 · 1对1定制化教学 · 竞赛考级全覆盖</p>
            
            <div class="hero-cta">
              <a class="cta-button primary" @click="showQRModal = true">
                <span>免费试听</span>
                <svg viewBox="0 0 20 20" fill="currentColor">
                  <path fill-rule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clip-rule="evenodd"/>
                </svg>
              </a>
            </div>

            <!-- <div class="hero-stats">
              <div class="stat-item">
                <span class="stat-number">1000+</span>
                <span class="stat-label">学员</span>
              </div>
              <div class="stat-divider"></div>
              <div class="stat-item">
                <span class="stat-number">50+</span>
                <span class="stat-label">专业讲师</span>
              </div>
              <div class="stat-divider"></div>
              <div class="stat-item">
                <span class="stat-number">98%</span>
                <span class="stat-label">好评率</span>
              </div>
            </div> -->
          </div>
          
          <div class="hero-visual">
            <div class="visual-card main-card">
              <div class="card-content">
                <div class="card-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/>
                  </svg>
                </div>
                <h3>编程思维培养</h3>
                <p>逻辑思维 · 创新能力 · 问题解决</p>
              </div>
            </div>
            <div class="visual-card float-card card-1">
              <div class="mini-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <polyline points="16 18 22 12 16 6"/>
                  <polyline points="8 6 2 12 8 18"/>
                </svg>
              </div>
              <span>C++ / Java / Python</span>
            </div>
            <div class="visual-card float-card card-2">
              <div class="mini-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <circle cx="12" cy="8" r="7"/>
                  <polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"/>
                </svg>
              </div>
              <span>竞赛辅导</span>
            </div>
            <div class="visual-card float-card card-3">
              <div class="mini-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                  <circle cx="9" cy="7" r="4"/>
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
                </svg>
              </div>
              <span>1对1教学</span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="courses-section">
      <div class="container">
        <div class="section-header">
          <h2 class="section-title">四大课程体系</h2>
          <p class="section-subtitle">涵盖各类编程学习需求，为孩子量身定制学习路径</p>
        </div>

        <div class="courses-grid">
          <div class="course-card" v-for="(course, index) in courses" :key="index" @click="jumpToCourse(course.link)">
            <div class="course-image">
              <img :src="course.image" :alt="course.title"/>
              <div class="course-overlay"></div>
            </div>
            <div class="course-content">
              <h3 class="course-title">{{ course.title }}</h3>
              <ul class="course-features">
                <li v-for="(feature, idx) in course.features" :key="idx">
                  <span class="feature-icon">✓</span>
                  {{ feature }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="features-section">
      <div class="container">
        <div class="section-header">
          <h2 class="section-title">为什么选择我们</h2>
          <p class="section-subtitle">专业的教学团队，完善的教学体系</p>
        </div>

        <div class="features-grid">
          <div class="feature-card" v-for="(feature, index) in features" :key="index">
            <div class="feature-icon-wrapper">
              <span class="feature-number">{{ index + 1 }}</span>
            </div>
            <h4 class="feature-title">{{ feature.title }}</h4>
            <ul class="feature-list">
              <li v-for="(item, idx) in feature.items" :key="idx">{{ item }}</li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <section class="teachers-section">
      <div class="container">
        <div class="teachers-content">
          <div class="teachers-text">
            <h2 class="section-title text-left">教学师资</h2>
            <p class="teachers-desc">
              团队教师都是来自于985高校计算机专业毕业的在线编程老师，为孩子提供专业指导和支持，有丰富的教学经验。
            </p>
            <p class="teachers-highlight">
              首席讲师硕士毕业于上海交通大学，在IT互联网行业深耕多年。
            </p>
            <div class="teacher-tags">
              <span class="tag">985高校</span>
              <span class="tag">计算机专业</span>
              <span class="tag">丰富经验</span>
            </div>
          </div>
          <div class="teachers-image">
            <img src="/images/teach.jpg" alt="教学团队"/>
          </div>
        </div>
      </div>
    </section>

    <section class="cta-section">
      <div class="container">
        <div class="cta-content">
          <div class="cta-image">
            <img src="/images/back2.jpg" alt="开始学习"/>
          </div>
          <div class="cta-text">
            <h2 class="cta-title">我要上课</h2>
            <p class="cta-desc">联系课程顾问获取课程价格以及上课方式</p>
            <div class="cta-qr">
              <img src="https://program.dctechonline.cn/static/images/head.jpg" alt="扫码咨询"/>
            </div>
          </div>
        </div>
      </div>
    </section>

    <bottom></bottom>

    <div class="qr-modal-overlay" v-if="showQRModal" @click.self="showQRModal = false">
      <div class="qr-modal-content">
        <button class="qr-modal-close" @click="showQRModal = false">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <line x1="18" y1="6" x2="6" y2="18"/>
            <line x1="6" y1="6" x2="18" y2="18"/>
          </svg>
        </button>
        <div class="qr-modal-header">
          <h3>扫码免费试听</h3>
          <p>添加课程顾问微信，获取免费试听课程</p>
        </div>
        <div class="qr-modal-body">
          <div class="qr-code-wrapper">
            <img src="https://program.dctechonline.cn/static/images/head.jpg" alt="扫码咨询"/>
          </div>
          <div class="qr-tips">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/>
              <circle cx="12" cy="13" r="4"/>
            </svg>
            <span>微信扫码添加客服</span>
          </div>
        </div>
      </div>
    </div>
</div>
</template>

<script>
import bottom from '../components/bottom.vue';

export default {
  name: "HomePage",
  components:{
      bottom
  },
  data() {
    return {
      showQRModal: false,
      courses: [
        {
          title: 'Python课程体系',
          image: 'https://program.dctechonline.cn/static/images/p1.jpg',
          link: '/python',
          features: [
            '适合零基础启蒙（8-10岁）',
            '游戏化，可视化教学',
            '无缝衔接C++或Java编程'
          ]
        },
        {
          title: 'C++课程体系',
          image: 'https://program.dctechonline.cn/static/images/p2.jpg',
          link: '/cpp',
          features: [
            '覆盖基础到竞赛',
            '衔接GESP考级',
            '衔接CSP-J/S'
          ]
        },
        {
          title: 'Java课程体系',
          image: 'https://program.dctechonline.cn/static/images/p3.jpg',
          link: '/java',
          features: [
            '覆盖Java基础到竞赛需求',
            'AP CSA考试5分目标班',
            'USACO 金银铜对标课程班'
          ]
        },
        {
          title: '算法课程体系',
          image: 'https://program.dctechonline.cn/static/images/classroom.jpg',
          link: '/algorithm',
          features: [
            '覆盖基础算法到高级算法',
            '竞赛算法专项训练',
            '计算思维与问题解决能力培养'
          ]
        }
      ],
      features: [
        {
          title: '课程特色',
          items: [
            '入门级课程助力快速入门',
            '进阶级教学助力快速提高',
            '1v1，1v2教学，高效课堂',
            '根据孩子的理解能力定制化课堂教学'
          ]
        },
        {
          title: '报名上课',
          items: [
            '添加客服确认孩子基本信息',
            '安排免费试听课，确认孩子基础',
            '安排正式课程上课时间，自动灵活'
          ]
        },
        {
          title: '练习与答疑',
          items: [
            '课后建立微信联系，不定时答疑',
            '课堂与课后练习互相结合',
            '比赛竞赛专项辅导，灵活多样',
            '其他常见问题，点击这里查看'
          ]
        }
      ]
    }
  },
  methods:{
      jump(url){
          location.href=url;
      },
      jumpToCourse(link){
          this.$router.push(link);
      },
      sendCode(){

      }
  }
};
</script>

<style lang="scss" scoped>
@import '../styles/variables.scss';
@import '../styles/mixins.scss';

.home {
  overflow-x: hidden;
}

.hero-section {
  position: relative;
  min-height: 100vh;
  display: flex;
  align-items: center;
  padding-top: 72px;
  background: linear-gradient(135deg, #f8fafc 0%, #e0e7ff 50%, #f0f9ff 100%);
  overflow: hidden;

  .hero-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
  }

  .hero-shape {
    position: absolute;
    border-radius: 50%;
    opacity: 0.6;
    
    &.hero-shape-1 {
      width: 600px;
      height: 600px;
      background: linear-gradient(135deg, rgba(99, 102, 241, 0.15) 0%, rgba(139, 92, 246, 0.1) 100%);
      top: -200px;
      right: -100px;
      animation: float 20s ease-in-out infinite;
    }
    
    &.hero-shape-2 {
      width: 400px;
      height: 400px;
      background: linear-gradient(135deg, rgba(59, 130, 246, 0.1) 0%, rgba(99, 102, 241, 0.08) 100%);
      bottom: -100px;
      left: -100px;
      animation: float 15s ease-in-out infinite reverse;
    }
    
    &.hero-shape-3 {
      width: 300px;
      height: 300px;
      background: linear-gradient(135deg, rgba(139, 92, 246, 0.1) 0%, rgba(236, 72, 153, 0.08) 100%);
      top: 40%;
      left: 30%;
      animation: float 18s ease-in-out infinite;
    }
  }

  .hero-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 80px;
    position: relative;
    z-index: 1;
    
    @include responsive(md) {
      flex-direction: column;
      text-align: center;
      gap: 60px;
    }
  }

  .hero-text {
    flex: 1;
    max-width: 580px;
    
    @include responsive(md) {
      max-width: 100%;
    }
  }

  .hero-badge {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 8px 16px;
    background: rgba(99, 102, 241, 0.1);
    border-radius: 50px;
    margin-bottom: 24px;
    animation: fadeInUp 0.6s ease forwards;
    
    svg {
      width: 16px;
      height: 16px;
      color: #f59e0b;
    }
    
    span {
      font-size: 13px;
      font-weight: 600;
      color: $primary-color;
      letter-spacing: 0.3px;
    }
  }

  .hero-title {
    font-size: 52px;
    font-weight: 800;
    line-height: 1.15;
    margin-bottom: 24px;
    color: $text-primary;
    
    @include responsive(md) {
      font-size: 36px;
    }

    .title-line {
      display: block;
      
      &.title-highlight {
        background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 50%, #a855f7 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
      }
    }
  }

  .hero-subtitle {
    font-size: 18px;
    color: $text-secondary;
    margin-bottom: 36px;
    line-height: 1.7;
    
    @include responsive(md) {
      font-size: 16px;
    }
  }

  .hero-cta {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 48px;
    
    @include responsive(md) {
      justify-content: center;
    }
  }

  .cta-button {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 14px 28px;
    font-size: 15px;
    font-weight: 600;
    border-radius: 14px;
    cursor: pointer;
    transition: all 0.3s ease;
    text-decoration: none;
    
    svg {
      width: 18px;
      height: 18px;
      transition: transform 0.3s ease;
    }
    
    &.primary {
      background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
      color: white;
      box-shadow: 0 4px 20px rgba(99, 102, 241, 0.35);
      
      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 8px 30px rgba(99, 102, 241, 0.45);
        
        svg {
          transform: translateX(4px);
        }
      }
    }
    
    &.secondary {
      background: white;
      color: $text-primary;
      border: 2px solid rgba(99, 102, 241, 0.2);
      
      &:hover {
        border-color: rgba(99, 102, 241, 0.4);
        background: rgba(99, 102, 241, 0.05);
      }
    }
  }

  .hero-stats {
    display: flex;
    align-items: center;
    gap: 24px;
    padding: 20px 28px;
    background: white;
    border-radius: 16px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
    
    @include responsive(sm) {
      flex-wrap: wrap;
      justify-content: center;
      gap: 16px;
      padding: 16px 20px;
    }
  }

  .stat-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
  }

  .stat-number {
    font-size: 28px;
    font-weight: 800;
    color: $primary-color;
    
    @include responsive(sm) {
      font-size: 24px;
    }
  }

  .stat-label {
    font-size: 13px;
    color: $text-muted;
    font-weight: 500;
  }

  .stat-divider {
    width: 1px;
    height: 40px;
    background: rgba(0, 0, 0, 0.08);
    
    @include responsive(sm) {
      display: none;
    }
  }

  .hero-visual {
    flex: 1;
    max-width: 520px;
    position: relative;
    height: 480px;
    
    @include responsive(md) {
      max-width: 100%;
      width: 100%;
      height: 400px;
    }
  }

  .visual-card {
    position: absolute;
    background: white;
    border-radius: 20px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
    
    &.main-card {
      width: 320px;
      height: 200px;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
      display: flex;
      align-items: center;
      justify-content: center;
      animation: fadeInUp 0.8s ease forwards;
      
      @include responsive(md) {
        width: 280px;
        height: 180px;
      }
      
      .card-content {
        text-align: center;
        color: white;
        
        .card-icon {
          width: 56px;
          height: 56px;
          margin: 0 auto 16px;
          padding: 14px;
          background: rgba(255, 255, 255, 0.2);
          border-radius: 16px;
          
          svg {
            width: 100%;
            height: 100%;
          }
        }
        
        h3 {
          font-size: 20px;
          font-weight: 700;
          margin-bottom: 8px;
        }
        
        p {
          font-size: 13px;
          opacity: 0.9;
        }
      }
    }
    
    &.float-card {
      padding: 14px 20px;
      display: flex;
      align-items: center;
      gap: 12px;
      animation: floatCard 3s ease-in-out infinite;
      
      .mini-icon {
        width: 40px;
        height: 40px;
        padding: 8px;
        background: linear-gradient(135deg, rgba(99, 102, 241, 0.1) 0%, rgba(139, 92, 246, 0.1) 100%);
        border-radius: 12px;
        
        svg {
          width: 100%;
          height: 100%;
          color: $primary-color;
        }
      }
      
      span {
        font-size: 14px;
        font-weight: 600;
        color: $text-primary;
      }
      
      &.card-1 {
        top: 20px;
        left: 0;
        animation-delay: 0s;
        
        @include responsive(md) {
          left: 10%;
        }
      }
      
      &.card-2 {
        top: 60px;
        right: 0;
        animation-delay: 0.5s;
        
        @include responsive(md) {
          right: 10%;
        }
      }
      
      &.card-3 {
        bottom: 60px;
        left: 20px;
        animation-delay: 1s;
        
        @include responsive(md) {
          left: 15%;
        }
      }
    }
  }
}

@keyframes float {
  0%, 100% {
    transform: translateY(0) rotate(0deg);
  }
  50% {
    transform: translateY(-30px) rotate(5deg);
  }
}

@keyframes floatCard {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.courses-section {
  padding: 100px 0;
  background: $bg-secondary;
  
  @include responsive(md) {
    padding: 60px 0;
  }
}

.section-header {
  text-align: center;
  margin-bottom: 60px;
  
  @include responsive(md) {
    margin-bottom: 40px;
  }
}

.section-title {
  font-size: 36px;
  font-weight: 700;
  color: $text-primary;
  margin-bottom: 16px;
  
  @include responsive(md) {
    font-size: 28px;
  }

  &.text-left {
    text-align: left;
  }
}

.section-subtitle {
  font-size: 16px;
  color: $text-secondary;
  max-width: 500px;
  margin: 0 auto;
  
  @include responsive(md) {
    font-size: 14px;
  }
}

.courses-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
  
  @include responsive(lg) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @include responsive(sm) {
    grid-template-columns: 1fr;
  }
}

.course-card {
  background: white;
  border-radius: $border-radius-lg;
  overflow: hidden;
  box-shadow: $shadow;
  transition: all $transition;
  cursor: pointer;
  
  &:hover {
    transform: translateY(-8px);
    box-shadow: $shadow-lg;
    
    .course-image img {
      transform: scale(1.05);
    }
    
    .course-overlay {
      opacity: 0.3;
    }
  }

  .course-image {
    position: relative;
    height: 160px;
    overflow: hidden;
    
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: transform $transition-slow;
    }
    
    .course-overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: $bg-gradient;
      opacity: 0;
      transition: opacity $transition;
    }
  }

  .course-content {
    padding: 24px;
  }

  .course-title {
    font-size: 18px;
    font-weight: 600;
    color: $text-primary;
    margin-bottom: 16px;
    padding-bottom: 12px;
    border-bottom: 2px solid rgba($primary-color, 0.2);
  }

  .course-features {
    list-style: none;
    padding: 0;
    margin: 0;
    
    li {
      display: flex;
      align-items: flex-start;
      gap: 8px;
      font-size: 14px;
      color: $text-secondary;
      margin-bottom: 8px;
      line-height: 1.5;
      
      &:last-child {
        margin-bottom: 0;
      }

      .feature-icon {
        color: $success-color;
        font-weight: bold;
        flex-shrink: 0;
      }
    }
  }
}

.features-section {
  padding: 100px 0;
  background: white;
  
  @include responsive(md) {
    padding: 60px 0;
  }
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 32px;
  
  @include responsive(md) {
    grid-template-columns: 1fr;
    gap: 24px;
  }
}

.feature-card {
  padding: 32px;
  background: $bg-secondary;
  border-radius: $border-radius-lg;
  transition: all $transition;
  
  &:hover {
    transform: translateY(-4px);
    box-shadow: $shadow-md;
  }

  .feature-icon-wrapper {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background: $bg-gradient;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
  }

  .feature-number {
    font-size: 20px;
    font-weight: 700;
    color: white;
  }

  .feature-title {
    font-size: 20px;
    font-weight: 600;
    color: $text-primary;
    margin-bottom: 16px;
  }

  .feature-list {
    list-style: none;
    padding: 0;
    margin: 0;
    
    li {
      position: relative;
      padding-left: 20px;
      font-size: 14px;
      color: $text-secondary;
      margin-bottom: 10px;
      line-height: 1.6;
      
      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 8px;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background: $primary-color;
      }
      
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}

.teachers-section {
  padding: 100px 0;
  background: $bg-secondary;
  
  @include responsive(md) {
    padding: 60px 0;
  }
}

.teachers-content {
  display: flex;
  align-items: center;
  gap: 60px;
  
  @include responsive(md) {
    flex-direction: column;
    gap: 40px;
  }
}

.teachers-text {
  flex: 1;
  
  .section-title {
    text-align: left;
    margin-bottom: 24px;
  }

  .teachers-desc {
    font-size: 16px;
    color: $text-secondary;
    line-height: 1.8;
    margin-bottom: 16px;
  }

  .teachers-highlight {
    font-size: 16px;
    color: $primary-color;
    font-weight: 500;
    margin-bottom: 24px;
  }

  .teacher-tags {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
    
    @include responsive(md) {
      justify-content: center;
    }
  }

  .tag {
    padding: 8px 16px;
    background: rgba($primary-color, 0.1);
    color: $primary-color;
    border-radius: 20px;
    font-size: 14px;
    font-weight: 500;
  }
}

.teachers-image {
  flex: 1;
  
  img {
    width: 100%;
    border-radius: $border-radius-lg;
    box-shadow: $shadow-lg;
  }
}

.cta-section {
  padding: 100px 0;
  background: white;
  
  @include responsive(md) {
    padding: 60px 0;
  }
}

.cta-content {
  display: flex;
  align-items: center;
  gap: 60px;
  
  @include responsive(md) {
    flex-direction: column;
    gap: 40px;
  }
}

.cta-image {
  flex: 1;
  
  img {
    width: 100%;
    border-radius: $border-radius-lg;
    box-shadow: $shadow-lg;
  }
}

.cta-text {
  flex: 1;
  
  .cta-title {
    font-size: 32px;
    font-weight: 700;
    color: $text-primary;
    margin-bottom: 16px;
    
    @include responsive(md) {
      font-size: 28px;
      text-align: center;
    }
  }

  .cta-desc {
    font-size: 16px;
    color: $text-secondary;
    margin-bottom: 24px;
    
    @include responsive(md) {
      text-align: center;
    }
  }

  .cta-qr {
    display: inline-block;
    padding: 16px;
    background: white;
    border-radius: $border-radius-lg;
    box-shadow: $shadow;
    
    @include responsive(md) {
      display: block;
      text-align: center;
    }
    
    img {
      max-width: 180px;
      border-radius: $border-radius;
    }
  }
}

.gradient-text {
  background: $bg-gradient;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.qr-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  z-index: 3000;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: fadeIn 0.3s ease;
  padding: 20px;
}

.qr-modal-content {
  position: relative;
  background: white;
  border-radius: 24px;
  box-shadow: 0 25px 60px rgba(0, 0, 0, 0.25);
  max-width: 400px;
  width: 100%;
  overflow: hidden;
  animation: scaleIn 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.qr-modal-close {
  position: absolute;
  top: 16px;
  right: 16px;
  width: 36px;
  height: 36px;
  border: none;
  background: rgba(0, 0, 0, 0.05);
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  z-index: 1;
  
  svg {
    width: 18px;
    height: 18px;
    color: $text-muted;
  }
  
  &:hover {
    background: rgba(0, 0, 0, 0.1);
    transform: rotate(90deg);
    
    svg {
      color: $text-primary;
    }
  }
}

.qr-modal-header {
  padding: 32px 32px 24px;
  text-align: center;
  
  h3 {
    font-size: 24px;
    font-weight: 700;
    color: $text-primary;
    margin: 0 0 8px;
    letter-spacing: -0.5px;
  }
  
  p {
    font-size: 14px;
    color: $text-secondary;
    margin: 0;
  }
}

.qr-modal-body {
  padding: 0 32px 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.qr-code-wrapper {
  width: 220px;
  height: 220px;
  padding: 16px;
  background: white;
  border-radius: 20px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  margin-bottom: 20px;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 12px;
  }
}

.qr-tips {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  background: linear-gradient(135deg, rgba(99, 102, 241, 0.08) 0%, rgba(139, 92, 246, 0.08) 100%);
  border-radius: 50px;
  
  svg {
    width: 18px;
    height: 18px;
    color: $primary-color;
  }
  
  span {
    font-size: 14px;
    font-weight: 500;
    color: $primary-color;
  }
}

@keyframes scaleIn {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
</style>
